import { createContext, useContext } from 'react';

export const InventoryShellContext = createContext({
  filterOptions: {},
});

export function useInventoryShell() {
  return useContext(InventoryShellContext);
}
